import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Global } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
//import {
//  Lists_dmcanbo
//} from '../../../routes/menu'
import 'jquery'
import 'bootstrap'
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';


const swal = require('sweetalert');
@Component({
    selector: 'app-quantri-taikhoannganhangedit',
  templateUrl: './taikhoannganhangedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./taikhoannganhangedit.component.scss'],
    providers: [ListService, Repository]
})


export class taikhoannganhangeditComponent implements OnInit {

    @ViewChild('mdDoiTuongChung', { static: false }) mdDoiTuongChung: ModalComponent;
    @ViewChild('dteChung', { static: false }) doituongchungedit: any;
    @ViewChild('slTaiKhoanNH', { static: false }) slTaiKhoanNH: any;
    @ViewChild('inputTenKB', { static: false }) inputTenKB: any;
    inputcapdonvis: any;
    inputvungmiens: any = [
      { Id: 0, Ten: "Miền Bắc" },
      { Id: 1, Ten: "Miền Trung" },
      { Id: 2, Ten: "Miền Nam" }
    ];
  inputtaikhoannganhangs: any;
  inputtinhs: any;
  inputxaphuongs: any;
  inputloais: any;

    quyen_them: boolean = false;
    quyen_sua: boolean = false;
    quyen_xoa: boolean = false;
    public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };

    inputparents: any;
    inputnganhangs: any;
  currentUser: any;

  
    donviid: any;
    tabselected: number = 1;

    indLoading: boolean = false;    
    doituongSelect: any = {
      Id: null,
      DonViId: null,
      BankId: null,
      SoTaiKhoan: null,
      ChuTaiKhoan: null,
      NganHang: null,
      ChiNhanh: null,
      GhiChu: null,
      MacDinh: null,
      Created: null,
      CreatedBy: null,
      Modified: null,
      ModifiedBy: null,
      TrangThai: null,
      ThuTu: null

    };    
    nhomdtid:string=null;


    @Output() save: EventEmitter<any> = new EventEmitter();
  
   

    constructor( private _dataService: ListService, private repo: Repository) {
       
        
    }

    ngOnInit(): void {
      

    }
  comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn_DV(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma.toLowerCase().indexOf(term) > -1 || item.Ten.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn_DV2(term: string, item: any) {
    term = term.toLowerCase();
    return  item.Ten.toLowerCase().indexOf(term) > -1;
  }

  public changeNganHang($event: any) {
    if (typeof $event === "undefined") {
      this.doituongSelect.BankId = null;
      this.doituongSelect.NganHang = null;
    }
    else {
      this.doituongSelect.BankId = $event.Id;
      this.doituongSelect.NganHang = $event.Ten;
    }
  }

  onDoiTuongChange($event) {

    if (typeof $event === "undefined") {
      this.doituongSelect.KBNN_Ten = null;
    }
    else
      this.doituongSelect.KBNN_Ten = $event.Ten_Doi_Tuong;
  }
    @ViewChild("mafocus",{static:false}) mafocus : ElementRef;

    loadDataInit(nhomdoituongid:string, id:string, donviid: string){

      var authlogin = localStorage.getItem('currentUser');
      if (authlogin) {

        this.currentUser = JSON.parse(authlogin);
        this.donviid = donviid;
        var giatri = this.currentUser.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
        if (giatri != null && giatri.length > 0) {
          if (giatri[0].Them == true)
            this.quyen_them = true;
          else
            this.quyen_them = false;
          if (giatri[0].Sua == true)
            this.quyen_sua = true;
          else
            this.quyen_sua = false;
          if (giatri[0].Xoa == true)
            this.quyen_xoa = true;
          else
            this.quyen_xoa = false;
        }
      }    

        this.nhomdtid = nhomdoituongid;
      //  setTimeout(() => {
      //      this.mafocus.nativeElement.focus();  
      //}, 500);
      
      this.repo.postRequest("api/taikhoannganhang/getnganhang/", { Id: id, UserName: this.currentUser.user_name })
        .subscribe(response => {
          this.inputtaikhoannganhangs = response;
        });
      
     

      this.doituongSelect = {
        Id: null,
        DonViId: this.donviid,
        BankId: null,
        SoTaiKhoan: null,
        ChuTaiKhoan: null,
        NganHang: null,
        ChiNhanh: null,
        GhiChu: null,
        MacDinh: null,
        Created: null,
        CreatedBy: null,
        Modified: null,
        ModifiedBy: null,
        TrangThai: true,
        ThuTu: null
       
      };    
        
        if(id === null)
        {
          this.doituongSelect.Created = new Date();
          this.doituongSelect.CreatedBy = this.currentUser.user_name;
          this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = this.currentUser.user_name;
          //this.repo.postRequest("api/donvibanle/getall/", { Id: null, UserName: this.currentUser.user_name })
          //  .subscribe(response => {
          //    this.inputparents = response;
          //  });
        }
        else {
          //this.repo.postRequest("api/donvibanle/getall/", { Id: id, UserName: this.currentUser.user_name })
          //  .subscribe(response => {
          //    this.inputparents = response;
          //  });

            console.log(id);
            this.repo.getRequest("api/taikhoannganhang/getbyid/" + id)
            .subscribe(response => {  
              console.log(response);
              this.doituongSelect.Id = id;
              this.doituongSelect.SoTaiKhoan = response.SoTaiKhoan;
              this.doituongSelect.BankId = response.BankId;
              this.doituongSelect.DonViId = response.DonViId;
              this.doituongSelect.NganHang = response.NganHang;
              this.doituongSelect.ChiNhanh = response.ChiNhanh;
              this.doituongSelect.ChuTaiKhoan = response.ChuTaiKhoan;
              this.doituongSelect.GhiChu = response.GhiChu;
              this.doituongSelect.TrangThai = response.TrangThai;
              if (response.Created != null)
              this.doituongSelect.Created = new Date(response.Created);
              this.doituongSelect.CreatedBy = response.CreatedBy;
              this.doituongSelect.Modified = new Date();
              this.doituongSelect.ModifiedBy = this.currentUser.user_name;
              this.doituongSelect.ThuTu = response.ThuTu;
            }); 
        }
        
       
    }
  selectedTab(tab: number) {
    this.tabselected = tab;
    if (tab === 2) {

    }
    else {
      setTimeout(() => {
        this.mafocus.nativeElement.focus();
      }, 100);
    }
   
  }
    keyTenPress(event: any) { 
        if (event.which === 13) {
          // this.slLoaiTaiSan.focus();
            event.preventDefault();
          }
  }
  keySoTKPress(event: any) {
    if (event.which === 13) {
       this.inputTenKB.focus();
      event.preventDefault();
    }
  }
  

  
    public closeModal(){
        this.save.emit(null);
    }
  public saveproduct() {

    if (this.doituongSelect.BankId == null || this.doituongSelect.BankId == "") {
      swal('Lỗi!', 'Vui lòng nhập ngân hàng!.', 'error');
      return;
    }


    if (this.doituongSelect.SoTaiKhoan == null || this.doituongSelect.SoTaiKhoan == "") {
      swal('Lỗi!', 'Vui lòng nhập số tài khoản!.', 'error');
      return;
    }
    

      
      
      this.repo.postRequest("api/taikhoannganhang/addorupdate",this.doituongSelect)
        .subscribe(response => {
            if (response != null && response.match('-')) {
          //if (response == 0 || (response != null && parseInt(response))) {
                      this.doituongSelect.Id = response;
                      this.save.emit(this.doituongSelect);
                    }
                    else {
                      swal('Lỗi!', response, 'error');
                    }
               
            }); 
    }
   
  comboSeleted: NgSelectComponent;
  AddDoiTuong(cobo: NgSelectComponent) {

    //this.comboSeleted = cobo;
    //cobo.close();
    //this.doituongchungedit.loadDataInit(Lists_dmcanbo.id, null, this.donviid);
    //this.mdDoiTuongChung.open();
  }
  saveModal(doituong: any) {
    console.log(doituong);
    this.mdDoiTuongChung.dismiss();
    this.comboSeleted.focus();
  }
   


}


